import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e786b69e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "send-balance" };
const _hoisted_2 = { class: "send-balance__container" };
const _hoisted_3 = {
    key: 0,
    class: "send-balance__container"
};
import { computed } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import i18n from '@/i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SendBalance',
    props: {
        lastSentDate: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const getNonOfficial = computed(() => {
            return store.getters.getNonOfficial;
        });
        const usedBalance = computed(() => {
            return getNonOfficial.value.limit - getNonOfficial.value.balance;
        });
        const renewalDate = computed(() => {
            return moment(getNonOfficial.value.startDate).format('DD/MM/YY');
        });
        const percentage = computed(() => {
            const value = (usedBalance.value / getNonOfficial.value.limit) * 100;
            return value.toLocaleString(store.getters.user?.language, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        });
        const currentDateTime = computed(() => {
            const date = moment(props.lastSentDate?.split(' ')[0]).format('DD/MM/YY');
            const time = props.lastSentDate.split(' ')[1];
            return i18n.global.t('360.campaigns.details.send-balance.updated-at', { date, time });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('360.campaigns.details.send-balance.usage')) + ": ", 1),
                        _createElementVNode("b", null, _toDisplayString(usedBalance.value), 1),
                        _createTextVNode(" / " + _toDisplayString(getNonOfficial.value.limit) + " (" + _toDisplayString(percentage.value) + "%) - " + _toDisplayString(_ctx.$t('360.campaigns.details.send-balance.renewal')) + " " + _toDisplayString(renewalDate.value), 1)
                    ])
                ]),
                (props.lastSentDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("span", null, _toDisplayString(currentDateTime.value), 1)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
